export class WebhookV1StandardPayloadClassificationJobSkipped {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadClassificationJobSkippedTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadClassificationJobSkippedArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadClassificationJobSkipped.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1StandardPayloadClassificationJobSkippedTypeEnum;
(function (WebhookV1StandardPayloadClassificationJobSkippedTypeEnum) {
    WebhookV1StandardPayloadClassificationJobSkippedTypeEnum["ClassificationJobSkipped"] = "CLASSIFICATION_JOB_SKIPPED";
})(WebhookV1StandardPayloadClassificationJobSkippedTypeEnum || (WebhookV1StandardPayloadClassificationJobSkippedTypeEnum = {}));
